import React, { useEffect, useState } from "react";
import { DateObject } from "react-multi-date-picker";
import { useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../Components/MDBox";
import MDTypography from "../../Components/MDTypography";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import persian from "react-date-object/calendars/persian";
import { ErrorToaast } from "../../utils/toast/Toast";
import { SenfMelkModel } from "../../Api/Models/SenfMelkModel";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Grid } from "@mui/material";
import MDButton from "../../Components/MDButton";
import MDDate from "../../Components/MDDate";
import MDInput from "../../Components/MDInput";
import { v4 as uuid } from "uuid";
import { AvarezSenfModel } from "../../Api/Models/AvarezSenfModel";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteNosaziRow from "./dialogs/DeleteNosaziRow";
import SelectGheymat from "../GheymatManteghei/Components/SelectGheymat";
const validationSchema = Yup.object().shape({
  GheymatMantaghei: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  DarsadTakhfif: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  NoeKarbari: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  MetrajMaaber: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  ShomareBlook: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
});
const ZaribTabaghe: any = {
  "0.95": "به ازای طبقات",
  "0.9": "به ازای زیر زمین ",
  "1": "بیرون از پاساژ و همکف",
};
const ZaribMasahat: any = {
  "24": "از 1 تا 20 متر مربع",
  "26": "از 20 تا 30 متر مربع",
  "28": "از 30 تا 40 متر مربع",
  "31": "از 40 تا 50 متر مربع",
  "33": "از 50 تا 70 متر مربع",
  "36": "از 70 تا 100 متر مربع",
  "48": "بالاتر از 100 متر مربع",
};
const InputDetail = ({ input, ...others }: any) => {
  return (
    <MDBox mx="6px" bgColor="#fefefe" borderRadius="4px" border="1px solid #757575" {...others}>
      <MDTypography fontSize="14px" py={0.25} fontWeight="bold" color="dark">
        {input ?? ""}
      </MDTypography>
    </MDBox>
  );
};
export default function AvarezSenf() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [melkSenfData, setMelkSenfData] = useState<any | null>(null);
  const date = new DateObject({ calendar: persian });
  const [counter, setCounter] = useState(0);
  const [deleteOpen, setDeleteOpen] = useState<{ open: boolean; id: number }>({ open: false, id: 0 });
  const senfMelk = new SenfMelkModel();
  const avarezSenf = new AvarezSenfModel();
  const [printable, setPrintable] = useState(false);
  const [selectGheymat, setSelectGheymat] = useState({ open: false });

  useEffect(() => {
    senfMelk
      .get(parseInt(id ?? "0"))
      .then((r) => {
        setMelkSenfData(r.data.data);

        // initFunction(r.data.data);
      })
      .catch((e) => {
        ErrorToaast("خطا در برقراری ارتباط");
        navigate("/", { replace: true });
      });
    return () => {};
  }, [counter]);

  const formik = useFormik({
    initialValues: {
      GheymatMantaghei: "",
      DarsadTakhfif: "0",
      NoeKarbari: "",
      MetrajMaaber: "",
      ShomareBlook: "",
      MablaghPasmand: "0",
      TozihBedehi: "",
      MablaghAvarez: "0",
      TedadSalBedehi: "0",
      TotalBedhiUntilNow: "0",
      TotalAll: "0",
    },
    validateOnChange: false,
    validateOnBlur: false,
    validateOnMount: false,
    validationSchema,

    onSubmit: (data: any) => {
      data.SenfMelkId = melkSenfData.id;
      avarezSenf
        .SubmitData(data)
        .then((r) => {
          if (printable) {
            setPrintable(false);
            window.open(`/webroutes/AllSenf/${r.data.data.id}`, "_blank");
          }
          setCounter((c) => c + 1);
        })
        .catch((e) => ErrorToaast("خطا در برقراری ارتباط"));
    },
  });
  const handleChange = () => {
    let { GheymatMantaghei, DarsadTakhfif } = formik.values;
    let { zaribMasahat, zaribTabaghe } = melkSenfData;
    let zaribEthadiye = melkSenfData.senf.gheymat;
    if (GheymatMantaghei !== "" && DarsadTakhfif !== "" && zaribMasahat !== "" && zaribTabaghe !== "" && zaribEthadiye !== "") {
      let count =
        (parseFloat(zaribTabaghe) ?? 0) *
        (parseFloat(zaribEthadiye) ?? 0) *
        (parseFloat(zaribMasahat) ?? 0) *
        Math.sqrt(10 * (parseFloat(GheymatMantaghei) ?? 0));

      let final = (count * (100 - (parseFloat(DarsadTakhfif) ?? 0))) / 100;
      formik.setFieldValue("MablaghAvarez", final.toFixed(0));
      formik.setFieldValue("MablaghPasmand", final.toFixed(0));
      formik.setFieldValue("TotalAll", (2 * final).toFixed(0));
    }
  };
  const handleSendPrint = async () => {
    await setPrintable(true);
    formik.submitForm();
  };
  const handleClickRows = (data: any) => {
    formik.setFieldValue("GheymatMantaghei", data.gheymat);
    formik.setFieldValue("MetrajMaaber", data.metrajMabar);
    setSelectGheymat((p) => ({ ...p, open: false }));
  };
  return (
    <DashboardLayout>
      <DashboardNavbar name={"صدور عوارض صنف"} />
      <MDBox>
        <Grid container columnGap={"5px"} wrap="nowrap">
          <Grid item xs={5}>
            <MDBox bgColor="#f8f8ff" borderRadius="5px" border={"0.8px #bababa solid"} py={2}>
              <MDTypography fontSize="16px" textAlign="center">
                مشخصات ملک و صنف
              </MDTypography>
              <MDBox pt={"1px"} bgColor="black" mb={3} />
              <Grid container alignItems={"center"} textAlign="center" rowGap={2}>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">تاریخ صدور</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={melkSenfData?.tarikhSodoor} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">شماره پرونده</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={melkSenfData?.shomareParvande} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">نام مالک</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={melkSenfData?.name} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">نام خانوادگی</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={melkSenfData?.lastName} />
                </Grid>

                <Grid item xs={2}>
                  <MDTypography fontSize="14px">نام پدر</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={melkSenfData?.fatherName} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">کد ملی</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={melkSenfData?.codeMelki} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">کد پستی</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={melkSenfData?.codePosti} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">شماره موبایل</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={melkSenfData?.shomareMobile} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">شاخه اصلی صنف</MDTypography>
                </Grid>
                <Grid item xs={10}>
                  <InputDetail input={melkSenfData?.senf.asnafCategory.title} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">زیر مجموعه</MDTypography>
                </Grid>
                <Grid item xs={10}>
                  <InputDetail input={melkSenfData?.senf.title} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">ضریب پسماند</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={melkSenfData?.zaribPasmand} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">ضریب اتحادیه</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={melkSenfData?.senf.gheymat} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">طبقات</MDTypography>
                </Grid>
                <Grid item xs={10}>
                  <InputDetail input={ZaribTabaghe[melkSenfData?.zaribTabaghe]} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">مساحت</MDTypography>
                </Grid>
                <Grid item xs={10}>
                  <InputDetail input={ZaribMasahat[melkSenfData?.zaribMasahat]} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">ضریب طبقه</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={melkSenfData?.zaribTabaghe} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">ضریب مساحت</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={melkSenfData?.zaribMasahat} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">مشخصات تابلو</MDTypography>
                </Grid>
                <Grid item xs={10}>
                  <InputDetail input={melkSenfData?.tabloDetail} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">عوارض تابلو</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={0} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">فرمول تابلو</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={0} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">متراژ مغازه</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={melkSenfData?.metraj} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">متراژ تابلو</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <InputDetail input={melkSenfData?.tabloMetraj} />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">آدرس محل کسب</MDTypography>
                </Grid>
                <Grid item xs={10}>
                  <InputDetail input={melkSenfData?.mahalKasb} />
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
          <Grid item xs={7} mb={4}>
            <MDBox bgColor="#f8f8ff" borderRadius="5px" border={"0.8px #bababa solid"} component="form" role="form" onSubmit={formik.handleSubmit}>
              <MDTypography fontSize="16px" textAlign="center" py={1}>
                صدور فیش
              </MDTypography>
              <MDBox pt={"1px"} bgColor="black" mb={3} />
              <Grid container alignItems={"center"} textAlign="center" rowGap={2} px={"12px"}>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">تاریخ فیش جدید</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDBox bgColor="white">
                    <MDDate
                      name={"DateEnd"}
                      // onChange={(e: any) => formikChild.setFieldValue("ExpireDate", e)}
                      portal
                      label={""}
                      defaultValue={date.format("YYYY-MM-DD")}
                      error={false}
                      size="small"
                      disabled
                      onChange={() => {}}
                      helperText={""}
                    />
                  </MDBox>
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px" sx={{ color: formik.errors.GheymatMantaghei ? "red" : "" }}>
                    شماره بلوک
                  </MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    sx={{ background: "white" }}
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="ShomareBlook"
                    value={formik.values.ShomareBlook}
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px" sx={{ color: formik.errors.GheymatMantaghei ? "red" : "" }}>
                    قیمت منطقه
                  </MDTypography>
                </Grid>
                <Grid item xs={4} onClick={() => setSelectGheymat((p) => ({ ...p, open: true }))}>
                  <MDInput
                    sx={{ background: "white" }}
                    fullWidth
                    size="small"
                    // onChange={formik.handleChange}
                    name="GheymatMantaghei"
                    value={formik.values.GheymatMantaghei}
                    autoComplete="off"

                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px" sx={{ color: formik.errors.MetrajMaaber ? "red" : "" }}>
                    متراژ معبر
                  </MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    sx={{ background: "white" }}
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="MetrajMaaber"
                    value={formik.values.MetrajMaaber}
                  />
                </Grid>

                <Grid item xs={2}>
                  <MDTypography fontSize="14px" sx={{ color: formik.errors.NoeKarbari ? "red" : "" }}>
                    نوع کاربری
                  </MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    sx={{ background: "white" }}
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="NoeKarbari"
                    value={formik.values.NoeKarbari}
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px" sx={{ color: formik.errors.DarsadTakhfif ? "red" : "" }}>
                    درصد تخفیف
                  </MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    sx={{ background: "white" }}
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="DarsadTakhfif"
                    value={formik.values.DarsadTakhfif}
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px" sx={{ color: formik.errors.MablaghAvarez ? "red" : "" }}>
                    مبلغ سال جاری
                  </MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    sx={{ background: "white" }}
                    fullWidth
                    disabled
                    size="small"
                    name="MablaghAvarez"
                    value={formik.values.MablaghAvarez}
                    // error={formik.touched.ShMobile && Boolean(formik.errors.ShMobile)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">مبلغ پسماند</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    sx={{ background: "white" }}
                    fullWidth
                    disabled
                    size="small"
                    // onChange={formik.handleChange}
                    value={formik.values.MablaghPasmand}
                    name="MablaghPasmand"
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">تعداد سال بدهی</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    disabled
                    sx={{ background: "white" }}
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    value={formik.values.TedadSalBedehi}
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">جمع بدهی تا سال جاری</MDTypography>
                </Grid>
                <Grid item xs={4}>
                  <MDInput
                    disabled
                    sx={{ background: "white" }}
                    fullWidth
                    size="small"
                    // onChange={formik.handleChange}
                    value={formik.values.TotalBedhiUntilNow}
                    // error={formik.touched.ShMobile && Boolean(formik.errors.ShMobile)}
                  />
                </Grid>

                <Grid item xs={2}>
                  <MDTypography fontSize="14px">توضیحات بدهی</MDTypography>
                </Grid>
                <Grid item xs={10}>
                  <MDInput
                    sx={{ background: "white" }}
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="TozihBedehi"
                    value={formik.values.TozihBedehi}
                    // error={formik.touched.ShMobile && Boolean(formik.errors.ShMobile)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize="14px">جمع کل</MDTypography>
                </Grid>
                <Grid item xs={10}>
                  <MDInput disabled sx={{ background: "white" }} fullWidth size="small" value={formik.values.TotalAll} />
                </Grid>
                <Grid container item p={2} columns={10} gap={2} wrap="nowrap">
                  <Grid item xs={2}>
                    <MDButton
                      fullWidth
                      width="100%"
                      variant="outlined"
                      color="success"
                      onClick={() => {
                        handleChange();
                      }}
                    >
                      محاسبه
                    </MDButton>
                  </Grid>
                  <Grid item xs={2}>
                    <MDButton fullWidth width="100%" variant="outlined" color="primary" onClick={formik.resetForm}>
                      جدید
                    </MDButton>
                  </Grid>
                  <Grid item xs={2}>
                    <MDButton fullWidth width="100%" variant="outlined" color="secondary" type="submit">
                      ثبت
                    </MDButton>
                  </Grid>
                  <Grid item xs={2}>
                    <MDButton
                      fullWidth
                      width="100%"
                      variant="outlined"
                      color="info"
                      onClick={() => {
                        handleSendPrint();
                      }}
                    >
                      ثبت و چاپ
                    </MDButton>
                  </Grid>
                  <Grid item xs={2}>
                    <MDButton
                      fullWidth
                      width="100%"
                      variant="outlined"
                      color="error"
                      onClick={() => window.open(`/webroutes/AllSenf/${id}`, "_blank")}
                    >
                      گزارش
                    </MDButton>
                  </Grid>
                </Grid>
              </Grid>
              <MDBox minHeight="40vh" maxHeight="40vh" sx={{ overflow: "auto" }} bgColor="#adaabb" border="1px solid #535353">
                <MDBox bgColor="#eeeeee" px={1}>
                  <Grid container gap="0 10px" columns={12} textAlign="center" wrap="nowrap" width={"100%"} overflow={"auto"}>
                    <Grid item xs={1} minWidth={"max-content"}>
                      <MDTypography fontSize={"14px"}> فیش</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>تاریخ</MDTypography>
                    </Grid>

                    <Grid item xs={2}>
                      <MDTypography fontSize={"14px"}>قیمت پسماند</MDTypography>
                    </Grid>
                    <Grid item xs={2}>
                      <MDTypography fontSize={"14px"}>قیمت عوارض</MDTypography>
                    </Grid>
                    <Grid item xs={2}>
                      <MDTypography fontSize={"14px"}>جمع کل</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>پرداخت</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>وضعیت</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>حذف</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>چاپ</MDTypography>
                    </Grid>
                  </Grid>
                </MDBox>
                {melkSenfData?.avarezSenfs.length > 0 &&
                  melkSenfData.avarezSenfs.map((data: any, index: number) => {
                    return (
                      <MDBox
                        bgColor={index % 2 === 0 ? "#fbfbfb" : "white"}
                        px={1}
                        key={uuid()}
                        onClick={() => {
                          // handleRowClick(data);
                          // setEditable(data.id);
                        }}
                        sx={{ ":hover": { background: "#9185c8" }, cursor: "pointer" }}
                      >
                        <Grid container columns={13} textAlign="center" gap="0 10px" wrap="nowrap">
                          <Grid item xs={1}>
                            <MDTypography fontSize={"14px"}>{index + 1}</MDTypography>
                          </Grid>
                          <Grid item xs={1}>
                            <MDTypography fontSize={"14px"}>{data?.created}</MDTypography>
                          </Grid>
                          <Grid item xs={2}>
                            <MDTypography fontSize={"14px"}>{(parseFloat(data.mablaghAvarez) / 2).toFixed(2)}</MDTypography>
                          </Grid>
                          <Grid item xs={2}>
                            <MDTypography fontSize={"14px"}>{(parseFloat(data.mablaghAvarez) / 2).toFixed(2)}</MDTypography>
                          </Grid>
                          <Grid item xs={2}>
                            <MDTypography fontSize={"14px"}>{parseFloat(data.mablaghAvarez).toFixed(2)}</MDTypography>
                          </Grid>
                          <Grid item xs={1}>
                            <MDTypography fontSize={"14px"}>پرداخت شده</MDTypography>
                          </Grid>
                          <Grid item xs={1}>
                            <MDTypography fontSize={"14px"}>پرداخت شده</MDTypography>
                          </Grid>
                          <Grid item xs={1} alignSelf="center">
                            <MDBox onClick={() => setDeleteOpen({ open: true, id: data.id })}>
                              <DeleteIcon color="error" />
                            </MDBox>
                          </Grid>
                          <Grid item xs={1} alignSelf="center">
                            <MDBox onClick={() => window.open(`/webroutes/senf/${data.id}`, "_blank")}>
                              <PrintIcon color="warning" />
                            </MDBox>
                          </Grid>
                        </Grid>
                      </MDBox>
                    );
                  })}
              </MDBox>
            </MDBox>
          </Grid>
        </Grid>
        <DeleteNosaziRow
          open={deleteOpen.open}
          id={deleteOpen.id}
          setClose={() => setDeleteOpen({ id: 0, open: false })}
          onDone={() => {
            setDeleteOpen({ open: false, id: 0 });
            setCounter((c) => c + 1);
          }}
        />
      </MDBox>
      <SelectGheymat
        open={selectGheymat.open}
        setClose={() => {
          setSelectGheymat((p: any) => ({ ...p, open: false }));
        }}
        handleClick={(data: any) => handleClickRows(data)}
        onDone={undefined}
      />
    </DashboardLayout>
  );
}
